function authHeaders() {
  const token = localStorage.getItem('walmates-token');
  return { Authorization: `Bearer ${token}` };
}

function userId() {
  return localStorage.getItem('walmates-user_id');
}

async function parseJson(res) {
  let body = null;
  try {
    body = await res.json();
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    throw new Error(body?.error || `Request failed (${res.status})`);
  }
  return body;
}

export async function fetchTodos() {
  const params = new URLSearchParams({ user_id: userId() });
  const res = await fetch(`/api/todo/get?${params}`, { headers: authHeaders() });
  return parseJson(res);
}

export async function addTodo(payload) {
  const res = await fetch('/api/todo/add', {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId(), ...payload }),
  });
  return parseJson(res);
}

export async function updateTodo(payload) {
  const res = await fetch('/api/todo/update', {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId(), ...payload }),
  });
  return parseJson(res);
}

export async function deleteTodo(id) {
  const res = await fetch('/api/todo/delete', {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId(), id }),
  });
  return parseJson(res);
}

export async function uploadTodoAttachment(todoId, selectedFile) {
  const form = new FormData();
  form.append('file', selectedFile);
  form.append('user_id', userId());
  form.append('todo_id', String(todoId));
  form.append('file_name', selectedFile.name);
  form.append('content_type', selectedFile.type || 'application/octet-stream');

  const res = await fetch('/api/todo/upload-file', {
    method: 'POST',
    headers: authHeaders(),
    body: form,
  });
  return parseJson(res);
}

export async function removeTodoAttachment(todoId, fileId) {
  const params = new URLSearchParams({
    user_id: userId(),
    todo_id: String(todoId),
    file_id: String(fileId),
  });
  const res = await fetch(`/api/todo/removefile?${params}`, {
    method: 'POST',
    headers: authHeaders(),
  });
  return parseJson(res);
}

export function todoFileUrl(file, disposition = 'inline') {
  const params = new URLSearchParams({
    user_id: userId(),
    file_id: String(file.file_id || file.id),
    disposition,
  });
  if (file.todo_id != null) params.set('todo_id', String(file.todo_id));
  return `/api/todo/file?${params}`;
}

export async function sendVoiceCommand({ text, audioBlob, context } = {}) {
  if (audioBlob) {
    const form = new FormData();
    form.append('user_id', userId());
    if (text) form.append('text', text);
    if (context) form.append('context', JSON.stringify(context));
    const name = audioBlob.name || 'audio.webm';
    form.append('audio', audioBlob, name);
    form.append('content_type', audioBlob.type || 'audio/webm');
    const res = await fetch('/api/todo/voice', {
      method: 'POST',
      headers: authHeaders(),
      body: form,
    });
    return parseJson(res);
  }
  const res = await fetch('/api/todo/voice', {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId(), text, context }),
  });
  return parseJson(res);
}

export async function fetchTodoAttachmentBlob(file, { disposition = 'inline' } = {}) {
  const res = await fetch(todoFileUrl(file, disposition), { headers: authHeaders() });
  if (!res.ok) throw new Error(`Failed to load file (${res.status})`);
  return res.blob();
}
